import { z } from "zod";

/**
 * Allowlist of entity ids the identification pipeline may consider.
 *
 * Empty (the default) means the full organization catalog. A non-empty list
 * lets authors roll a workflow out to a subset of customers or suppliers.
 */
export const eligibleEntityIdsSchema = z
  .array(z.uuid())
  .max(500)
  .default([])
  .describe(
    "When non-empty, matching only considers these entity ids. Empty means the full organization catalog.",
  );
